module.exports = __webpack_public_path__ + "Titillium-Bold.228729e002be037a045b.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Titillium-Bold.otf
// module id = 376
// module chunks = 8